/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import store, { persistor } from './app/store/store';
import { mockAxios, setupAxios } from './redux/utils';
import App from './app/App';
import './index.scss'; // Standard version
import './_metronic/_assets/plugins/keenthemes-icons/font/ki.css';
import 'socicon/css/socicon.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './_metronic/_assets/plugins/flaticon/flaticon.css';
import './_metronic/_assets/plugins/flaticon2/flaticon.css';
import 'react-datepicker/dist/react-datepicker.css';
import { MetronicLayoutProvider, MetronicSplashScreenProvider, MetronicSubheaderProvider } from './_metronic/layout';
import { MetronicI18nProvider } from './_metronic/i18n';
import 'rsuite/dist/rsuite.min.css';

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
mockAxios(axios);

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios, store);

const root = document.querySelector('body');

switch (window.location.hostname) {
    case process?.env?.REACT_APP_THEME_CUOTAYA_HOST:
        root.setAttribute('theme', 'cuota-ya');
        break;
    case process?.env?.REACT_APP_THEME_DEMO_HOST:
        root.setAttribute('theme', 'demo');
        break;
    default: root.setAttribute('theme', 'demo'); break;
}
const params = new URL(document.location).searchParams;

if (params.has('theme') && ['cuota-ya', 'demo'].includes(params.get('theme'))) {
    root.setAttribute('theme', params.get('theme'));
}

ReactDOM.render(
    <MetronicI18nProvider>
        <MetronicLayoutProvider>
            <MetronicSubheaderProvider>
                <MetronicSplashScreenProvider>
                    <App
                        store={store}
                        persistor={persistor}
                    />
                </MetronicSplashScreenProvider>
            </MetronicSubheaderProvider>
        </MetronicLayoutProvider>
    </MetronicI18nProvider>,
    document.getElementById('root')
);
